import React, { useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import ImageLight from "../assets/img/login-office.jpeg";
import ImageDark from "../assets/img/login-office-dark.jpeg";
import Atenea from "../assets/img/atenea.jpg";
import { GithubIcon, TwitterIcon } from "../icons";
import { Label, Input, Button } from "@windmill/react-ui";
import { jwtDecode } from "jwt-decode";
import { SidebarContext } from "../context/SidebarContext";
const { REACT_APP_LOGIN } = process.env;
export function LogIt(data) {
  const pars = useParams();

  console.log(pars);
  sessionStorage.setItem("token", pars.token);
  window.location.href = "/";
}



function LoginPublic(params) {
  return ( <div className="h-screen content-center justify-center">
    <section class="bg-white dark:bg-gray-900">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center">
          <div class=" m-15">
            <div
              class={`w-48 h-48 bg-indigo-100 mx-auto rounded-full shadow-2xl  inset-x-0  -mt-24 flex items-center justify-center text-indigo-500 ${
                "overflow-hidden"
              }`}
            >
              <img src={Atenea} alt="bookCover" />
            </div>
          </div>
          <p class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Obten acceso
          </p>
          <p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Los usuarios autenticados pueden tener acceso total a este y a otros miles de documentos.{" "}
          </p>
          <a
            href="https://atenea.instipp.edu.ec"
            class="inline-flex text-black bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
          >
            IR A ATENEA
          </a>
        </div>
      </div>
    </section>
  </div>

  );
  {
    /* <div>
    Para ingresar al sistema debe logearse en atenea

    <a href="https://atenea.instipp.edu.ec" target="_blank">Ir a Google</a>
  </div> */
  }
}
export default LoginPublic;
